import promise from 'redux-promise';
import rootReducer from './reducers';
import { configureStore } from '@reduxjs/toolkit';

export interface User {
  username?: string;
  permissions?: string[];
  firstName?: string;
  lastName?: string;
  displayName?: string;
}

const store = configureStore({ middleware: [promise], reducer: rootReducer as any });

export default store;
